import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, pairwise, startWith } from 'rxjs/operators';

interface HeatTraceFilterState {
  week: string | null;
  date: string | null;
}

@Injectable({ providedIn: 'root' })
export class HeatTraceFilterStateService {
  private filterState: HeatTraceFilterState = {
    week: null,
    date: null,
  };

  constructor(private readonly router: Router) {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((event) => event.urlAfterRedirects),
        startWith(this.router.url),
        pairwise(),
      )
      .subscribe(([previousUrl, currentUrl]) => {
        if (this.isHeatTraceUrl(previousUrl) && !this.isHeatTraceUrl(currentUrl)) {
          this.clear();
        }
      });
  }

  setFromWeek(week: string): void {
    this.filterState = {
      week,
      date: null,
    };
  }

  setFromDate(date: string): void {
    this.filterState = {
      week: null,
      date,
    };
  }

  get(): HeatTraceFilterState {
    return { ...this.filterState };
  }

  clear(): void {
    this.filterState = {
      week: null,
      date: null,
    };
  }

  private isHeatTraceUrl(url: string): boolean {
    const [path] = url.split('?');
    return path.startsWith('/heat-trace');
  }
}
